import { useRoute, useRouter } from "vue-router";

export function useCleanQueryParams() {
    const route = useRoute();
    const router = useRouter();

    return {
        cleanQueryParams(paramNames) {
            if (!paramNames || !paramNames.length) {
                return;
            }

            const { name, query } = route;
            const newQuery = { ...query };
            for (const paramName of paramNames) {
                if (!newQuery[paramName]) {
                    continue;
                }
                delete newQuery[paramName];
            }
            return router.replace({ name, query: newQuery });
        },
    };
}
